export default '@@RESIFT/SUCCESS';
